import React, {useEffect} from "react";
import './AnalizaMain.css';
import {useHistory} from "react-router-dom";
import * as BiIcons from "react-icons/bi";
import TeX from '@matejmazur/react-katex';


export default function Nierownosci(){

    useEffect(()=>{
        document.title="Nierównośći";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }

    return(
        <div  className='conceptsContainer'>
            <div className='comeBackDiv' onClick={comeBackFunc}>
                <BiIcons.BiArrowBack/>
                <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
            </div>

            <h1>Nierówności stopnia pierwszego z jedną niewiadomą</h1><br/>
            <h4>Mówimy, że mamy nierówność stopnia n, gdy połączymy dwa wielomiany, gdzie jeden jest stopnia <TeX math={'n'}/>, a drugi
                co najwyżej stopnia <TeX math={'n'}/>.</h4><br/>
            <p>Nierówność stopnia pierwszego nazywamy nierównością liniową, a nierówność stopnia drugiego nierównością kwadratową.</p>
            <p>Nierówność ze znakiem &#60; lub &#62; nazywamy nierównością ostrą, a ze znakiem &#8804; lub &#8805; nazywamy nierównością
            słabą.</p>

            <br/><br/>

            <p>Dwie nierówności nazywamy nierównościami równoważnymi, jeżeli mają takie same rozwiązanie. Możemy również,
                wtedy wywnioskować, że:</p>
            <ul>
                <li>Jeżeli do obydwu stron nierówności dodamy ten sam wielomian, to otrzymamy nierówność równoważną.</li>
                <li>Jeżeli obydwie strony nierówności pomnożymy przez liczbę dodatnią, to otrzymamy nierówność równoważną.</li>
                <li>Jeżeli obydwie strony nierówności pomnożymy przez liczbę ujemną, to musimy zmienić znak nierówności, żeby
                otrzymać nierówność równoważną.</li>
            </ul>

            <br/><br/>

            <h2>Równania i nierówności modułowe</h2>
            <p>Jeżeli niewiadoma występuje pod wartością bezwzględną (tj. znakiem modułu) to możemy zapisać następujące zależności:</p>
            <p><TeX math={'a'}/> - oznacza dowolną liczbę rzeczywistą, <TeX math={'b'}/> - oznacza dowolną liczbę dodatnią.</p>
            <p>1)&nbsp;&nbsp;(|<TeX math={'x-a'}/>|&#62;<TeX math={'b'}/> &#8743; (<TeX math={'b'}/>&#62;0)) &#8801;
                ((<TeX math={'x'}/>&#60;<TeX math={'a-b'}/>)&#8744;(<TeX math={'x'}/>&#62;<TeX math={'a+b'}/>)),</p>
            <p>2)&nbsp;&nbsp;((|<TeX math={'x-a'}/>|&#60;<TeX math={'b'}/> &#8743; (<TeX math={'b'}/>&#62;0)) &#8801;
                (<TeX math={'a-b'}/>&#60;<TeX math={'x'}/>&#60;<TeX math={'a+b'}/>).</p>

            <br/><br/>
            <p>Przykład:</p>
            <p>Nierówność: |<TeX math={'x'}/>+4|>3 jest równoważna alternatywie nierówności:</p>
            <p>1)&nbsp;&nbsp;(|<TeX math={'x'}/>-(-4)|&#62;3 &#8743; (3&#62;0)) &#8801; ((<TeX math={'x'}/>&#60;(-4)-3)&#8744;
                (<TeX math={'x'}/>&#62;(-4)+3)),</p>
            <p><TeX math={'x'}/>&#60;-7 &#8744; <TeX math={'x'}/>&#62;-1</p>

            <br/><br/><br/>
        </div>
    );
}